export enum SessionStatusEnum {
  New = 'New',
  Active = 'Active',
  Paused = 'Paused',
  Error = 'Error',
  Archived = 'Archived',
  Deleted = 'Deleted'
}
